// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"98f3c641","685":"60ddfc77","787":"be374c60","889":"0bd7015c"}[chunkId] + ".chunk.js";
};